<script setup>
import { watch, ref, nextTick } from "vue";

const props = defineProps({
  mune: {
    type: Array,
    default: () => {},
  },
  bannerHeight: {
    type: String,
    default: "",
  },
  actived: {
    type: String,
    default: "",
  },

});
const emit = defineEmits(["changeTab",'actived']);
const actived = ref("");
const changetab = data => {
  actived.value = data.type;
  emit("changeTab", data);
  // emit("update:actived", data.type);
  nextTick(() => {
    setTimeout(() => {
      let scrollTop = window.scrollY;
      if (scrollTop == props.bannerHeight) return;
      window.scroll(0, props.bannerHeight);
    }, 0);
  });
};

watch(
  () => props.mune,
  val => {
    if(props.actived){
      actived.value = props.actived
    }else{
      actived.value = props.mune[0] ? props.mune[0].type : "";

    }
    emit("changeTab", {type:actived.value});
  },
  {
    immediate: true,
  }
);
</script>
<script>
export default {
  name: "nextMune",
};
</script>
<template>
  <div
    class="nextMune isFixed"
    data-aos="zoom-in-down"
    data-aos-anchor="top-center"
    data-aos-once="true"
  >
    <div
      class="nextMune-center "
      data-aos="zoom-in"
      data-aos-delay="200"
      data-aos-anchor="top-center"
    >
      <div
        class="nextMune-center-item"
        v-for="item in props.mune"
        @click="changetab(item)"
        :class="[item.type === actived ? 'navActived' : '']"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.nextMune {
  background: #fafafa;
 
  // border-bottom: 1px solid #d7d7d7;
}
.isFixed {
  position: sticky;
  top: 0px;
  z-index: 1000;
}

.nextMune-center {
  display: flex;
  justify-content: space-around;
  margin: auto 15vw;
  .nextMune-center-item {
    flex: 1;
    font-weight: 800;
    font-size: 1rem;
    line-height: 1.5em;
    padding:1.5rem;
    text-align: center;
    cursor: pointer;

    position: relative;
    transition: all 300ms ease-out;
    background-size: 100% 200%;
    background-position: right top;
    background-image: linear-gradient(to bottom, #fafafa 50%, #1485d3 50%);
  }
  & > :hover {
    color: #fff;
    background-position: left bottom;
  }
  .navActived {
    background: #0670b9 !important;
    color: #fff;
  }
}
@media screen and (max-width: 1600px) {
  .nextMune-center {
    margin: auto 4vw;
  }
}
@media screen and (max-width: 1366px) {
  .nextMune-center {
    margin: auto 5vw;
  }
}
@media screen and (max-width: 1024px) {
  .nextMune-center {
    margin: auto 0;
    .nextMune-center-item {
      // font-size: 3.5333vw;
      line-height: 60px;
    }
  }
}
@media screen and (max-width: 992px) {
  .nextMune-center-item {
      font-size: 3vw;
      
    }
}
</style>
